/*
 * Nothing really interesting here. This is a basic drag and drop implementation that relies on the HTML5 API.
 * Mostly for demo purposes. The real meat is found under dragdrop-keyboard.js.
 */
export default class DragDropMouse {
  constructor(params = {}) {
    const { container } = params;
    
    if (container instanceof HTMLElement) {
      this.list = container;
    } else if (typeof container === 'string') {
      this.list = document.querySelector(container);
    }
    
    this.dragEl = null;
    this.captureEl = null;
    
    if (this.list) {
      this.initEvents();
    }
  }
  
  /*
   * Initializes event handlers.
   */
  initEvents() {
    this.list.addEventListener('mousedown', this.handleMouseDown.bind(this), false);
    this.list.addEventListener('mouseup', this.handleResetDrag.bind(this), false);
    this.list.addEventListener('dragstart', this.handleDragStart.bind(this), false);
    this.list.addEventListener('dragover', this.handleDragOver.bind(this), false);
    this.list.addEventListener('drop', this.handleDrop.bind(this), false);
    this.list.addEventListener('dragend', this.handleResetDrag.bind(this), false);
  }
  
  /*
   * Since it isn't desirable for the entire LI to be a drag target,
   * only make it draggable when the inner drag handle is activated on mousedown.
   */
  handleMouseDown(evt) {
    let target = evt.target;
    
    // Traverse up from delegate to locate the LI.
    while (target) {
      // Using button's parent as target, since Firefox doesn't support drag drop from button elements.
      if (target.classList && target.classList.contains('drag-handle')) {
        this.dragEl = target.parentNode;
        break;
      } else {
        target = target.parentNode;
      }
    }
    
    if (this.dragEl) {
      // Make LI item draggable.
      this.dragEl.draggable = true;
    }
  }
  
  /*
   * Reset LI's `draggable` property to false after mouse operation completes.
   */
  handleResetDrag() {
    if (this.dragEl) {
      // Disable drag on LI item.
      this.dragEl.draggable = false;
      this.dragEl = null;
    }
  }
  
  /*
   * Required for drag and drop to properly work in Firefox.
   */
  handleDragStart(evt) {
    evt.dataTransfer.setData('text/plain', '');
  }
  
  /*
   * Handle the elements being dropped into.
   */
  handleDragOver(evt) {
    let target = evt.target;
    
    // Traverse up from delegate to locate the LI.
    while (target) {
      if (target.tagName && target.tagName === 'LI') {
        this.captureEl = target;
        break;
      } else {
        target = target.parentNode;
      }
    }
    
    // Enable element to be `dropped` into.
    if (this.captureEl) {
      evt.preventDefault();
    }
  }
  
  /*
   * Reposition the elements in the DOM based on the new sort order.
   */
  handleDrop(evt) {
    if (this.captureEl) {
      const sibling = this.captureEl.nextElementSibling;
      
      // Insert element into new position.
      if (sibling) {
        const shouldInsertBeforeSibling = (this.captureEl !== this.list.firstElementChild) && (sibling !== this.dragEl);
        this.list.insertBefore(this.dragEl, shouldInsertBeforeSibling ? sibling : this.captureEl);
      } else {
        // Use appendChild if moving to last position in the list.
        this.list.appendChild(this.dragEl);
      }
      
      this.captureEl = null; 
    }
  }
};



// WEBPACK FOOTER //
// in/scripts/dragdrop-mouse.js